export interface GetQuestionParams {
  pageNo: number;
  perPage: number;
  search: string;
  userType: string;
  isDependentEligible?: boolean;
}

export interface GetQuestionResponse {
  totalRecord: number;
  results: QuestionField[];
}

export interface QuestionField {
  id: number;
  categoryName: string;
  userType: UserType;
  label: string;
  description?: string;
  fieldType: string;
  displayOrder: number;
  validationRules: Record<string, any>;
  questionOptionsResponse: QuestionOption[];
  createdBy?: string;
}

export interface QuestionOption {
  id: number;
  optionLabel: string;
  optionValue: string;
  displayOrder: number;
}

export interface PostQuestionOption {
  optionLabel: string;
  optionValue: string;
  displayOrder: number;
}

export interface PostQuestionRequest {
  questionCategoryId?: number;
  userType: UserType;
  label: string;
  description?: string;
  fieldType: string;
  displayOrder: number;
  validationRules?: Record<string, any>;
  options?: PostQuestionOption[];
  category?: string;
  shouldShowIf?: "Yes" | "No";
  dependentQuestionId?: number | null;
}

// One entry of the bulk reorder payload — `PATCH /admin/questions` takes an
// array of these covering every reordered question (see
// services/api/questionnaire.ts's `updateQuestionsOrder`).
export interface QuestionOrderItem {
  questionId: number;
  displayOrder: number;
}

export interface PostQuestionResponse {
  id?: number;
  message?: string;
  [key: string]: any;
}

export type UserType = "FOUNDER" | "INVESTOR";

export type QuestionRow = QuestionField & {
  questionCategoryId?: number;
  categoryId?: number;
};

export const DEFAULT_QUESTION_PAGE = 1;
export const QUESTION_TABLE_HEIGHT = "calc(100vh - 100px)";

export const questionTypeOptions = [
  { label: "Single Line", value: "text" },
  { label: "Multiple Choice", value: "checkbox" },
  { label: "Yes/No", value: "radio" },
  { label: "Range / Scale", value: "range" },
  { label: "Date Picker", value: "date" },
  { label: "Website / URL", value: "url" },
];

export const assignToOptions = [
  { label: "Founder", value: "FOUNDER" },
  { label: "Investor", value: "INVESTOR" },
];
